import { render } from "./ClosingBalanceView.vue?vue&type=template&id=189f5a6e"
import script from "./ClosingBalanceView.vue?vue&type=script&lang=js"
export * from "./ClosingBalanceView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__